import { createContext, useState, useContext, useEffect, useMemo } from "react";
import {
  getAccessTokenLocalStorage,
  ValidAccessTokenLocalStorage,
  handleUserLogOutErro,
  setDateTimeAudienceStorage,
  getUserPreferenceLocalStorage,
} from "./utils";
import { UserPreferenceContext } from "./UserPreferenceContext";
import { GetDateTimeAudience } from "../services/DateTimeAudienceService";
import { IDateTimeAudienceCountry } from "./types";

export const DateTimeAudienceContext = createContext({} as any);

const DateTimeAudience = ({ children }) => {
  const { userAuthenticated, setUserAuthenticated, setUserMenssageApi } =
    useContext(UserPreferenceContext);

  const [countryId, setCountryId] = useState(1);
  const [dateTimeAudience, setDateTimeAudience] =
    useState<IDateTimeAudienceCountry>();

  useEffect(() => {
    doDateTimeAudience()
      .then((res) => {})
      .catch((err) => {});
  }, [countryId]);

  function changeCountryId(id) {
    setCountryId(id);
  }

  async function doDateTimeAudience() {
    let token = getAccessTokenLocalStorage();
    const userPreferenceStorage = getUserPreferenceLocalStorage();
    if (ValidAccessTokenLocalStorage()) {
      let countryIdResquest = countryId;
      if (userPreferenceStorage) {
        countryIdResquest = userPreferenceStorage.countryID ?? countryId;
      }
      await GetDateTimeAudience(token, countryIdResquest)
        .then((res) => {
          const resultData: IDateTimeAudienceCountry = res.data;
          setDateTimeAudience(resultData);
          setDateTimeAudienceStorage(resultData);
        })
        .catch((err) => {
          handleUserLogOutErro(
            err,
            userAuthenticated,
            setUserAuthenticated,
            setUserMenssageApi
          );
        });
    }
  }

  const objMemoProvider = useMemo(
    () => ({ dateTimeAudience, doDateTimeAudience, changeCountryId }),
    [dateTimeAudience]
  );
  
  
  return (
    <DateTimeAudienceContext.Provider value={objMemoProvider}>
      {children}
    </DateTimeAudienceContext.Provider>
  );
};
export default DateTimeAudience;
